// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".broad-open-answer[data-v-5eda0459]{display:flex;flex-direction:column;align-content:flex-start}.text-answer[data-v-5eda0459]{max-width:400px;word-break:break-word;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
